(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initScHeaderHoverMenus(scope = document) {
    const headers = scope.querySelectorAll('.sc-header--menu-open-hover');

    headers.forEach((header) => {
      header.querySelectorAll('header-menu > details').forEach((details) => {
        if (details.dataset.scHoverReady === 'true') return;
        details.dataset.scHoverReady = 'true';

        const summary = details.querySelector('summary');

        details.addEventListener('mouseenter', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          details.setAttribute('open', '');
          summary?.setAttribute('aria-expanded', 'true');
        });

        details.addEventListener('mouseleave', () => {
          if (!window.matchMedia('(min-width: 990px)').matches) return;
          if (details.contains(document.activeElement)) return;
          details.removeAttribute('open');
          summary?.setAttribute('aria-expanded', 'false');
        });
      });
    });
  }

  initScHeaderHoverMenus();
  document.addEventListener('shopify:section:load', (event) => initScHeaderHoverMenus(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-campaign-canvas"] && !Shopify.designMode) return;
  try {
    
  class ScCampaignCanvas extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-sc-campaign-video-toggle]').forEach((button) => {
        if (button.dataset.ready === 'true') return;
        const panel = button.closest('.sc-campaign-mosaic__media, .sc-campaign-video-panel');
        const video = panel?.querySelector('video');
        if (!video) return;
        button.dataset.ready = 'true';
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            button.setAttribute('aria-label', 'Pause video');
            button.querySelector('[data-sc-campaign-video-label]').textContent = 'Pause';
          } else {
            video.pause();
            button.setAttribute('aria-label', 'Play video');
            button.querySelector('[data-sc-campaign-video-label]').textContent = 'Play';
          }
        });
      });
    }
  }

  if (!customElements.get('sc-campaign-canvas')) {
    customElements.define('sc-campaign-canvas', ScCampaignCanvas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-customer-preferences"] && !Shopify.designMode) return;
  try {
    
  class ScCustomerPreferences extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.form = this.querySelector('[data-sc-customer-preferences-form]');
      this.fields = Array.from(this.querySelectorAll('[data-sc-preference-field]'));
      this.status = this.querySelector('[data-sc-preferences-status]');
      this.submit = this.querySelector('[data-sc-preferences-submit]');
      this.openConfirm = this.querySelector('[data-sc-preferences-open-confirm]');
      this.confirmPanel = this.querySelector('[data-sc-preferences-confirm]');
      this.cancelConfirm = this.querySelector('[data-sc-preferences-cancel]');
      this.defaultSubmitLabel = this.submit?.textContent.trim() || '';
      this.profile = null;

      this.submitHandler = (event) => {
        event.preventDefault();
        this.save();
      };
      this.openHandler = () => {
        if (this.confirmPanel) this.confirmPanel.hidden = false;
        if (this.openConfirm) this.openConfirm.hidden = true;
        this.submit?.focus();
      };
      this.cancelHandler = () => {
        if (this.confirmPanel) this.confirmPanel.hidden = true;
        if (this.openConfirm) this.openConfirm.hidden = false;
        this.openConfirm?.focus();
      };
      this.form?.addEventListener('submit', this.submitHandler);
      this.openConfirm?.addEventListener('click', this.openHandler);
      this.cancelConfirm?.addEventListener('click', this.cancelHandler);
      if (this.dataset.endpoint) this.load();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.submitHandler);
      this.openConfirm?.removeEventListener('click', this.openHandler);
      this.cancelConfirm?.removeEventListener('click', this.cancelHandler);
    }

    valueAt(source, path) {
      if (!path) return undefined;
      return path.split('.').reduce((value, key) => (value == null ? undefined : value[key]), source);
    }

    converted(value, type) {
      if (type === 'boolean') return String(value).toLowerCase() === 'true';
      if (type === 'number') return Number(value);
      return value == null ? '' : String(value);
    }

    populate(profile) {
      this.profile = profile || {};
      this.fields.forEach((field) => {
        if (field.dataset.fieldKind === 'hidden' && field.dataset.useLoadedValue !== 'true') return;
        const value = this.valueAt(this.profile, field.dataset.valuePath);
        if (value === undefined || value === null) {
          if (field.dataset.fallback !== undefined) field.value = field.dataset.fallback;
          return;
        }
        if (field.dataset.fieldKind === 'checkbox') field.checked = Boolean(value);
        else field.value = value;
      });
    }

    payload() {
      const payload = {};
      this.fields.forEach((field) => {
        const key = field.dataset.payloadKey;
        if (!key) return;
        if (field.dataset.fieldKind === 'checkbox') payload[key] = field.checked;
        else payload[key] = this.converted(field.value, field.dataset.valueType);
      });
      return payload;
    }

    setStatus(message, error = false) {
      if (!this.status) return;
      this.status.textContent = message || '';
      this.status.classList.toggle('is-error', error);
    }

    setBusy(busy) {
      this.form?.setAttribute('aria-busy', String(busy));
      this.fields.forEach((field) => { field.disabled = busy; });
      if (this.openConfirm) this.openConfirm.disabled = busy;
      if (this.submit) {
        this.submit.disabled = busy;
        this.submit.textContent = busy ? (this.dataset.savingLabel || 'Saving...') : this.defaultSubmitLabel;
      }
    }

    async response(request, fallbackMessage) {
      const response = await request;
      const data = await response.json();
      if (!response.ok || data?.ok === false) throw new Error(data?.message || fallbackMessage || 'Request failed');
      return data;
    }

    async load() {
      this.setBusy(true);
      this.setStatus(this.dataset.loadingLabel || 'Loading your details...');
      try {
        const data = await this.response(fetch(this.dataset.endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }), this.dataset.loadErrorLabel);
        this.populate(this.valueAt(data, this.dataset.responsePath) || data);
        this.setStatus('');
      } catch (error) {
        this.setStatus(error.message || this.dataset.loadErrorLabel || 'We could not load these details just now.', true);
      } finally {
        this.setBusy(false);
      }
    }

    async save() {
      if (!this.dataset.endpoint || !this.form?.reportValidity()) return;
      this.setBusy(true);
      this.setStatus('');
      try {
        const data = await this.response(fetch(this.dataset.endpoint, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(this.payload()),
        }), this.dataset.saveErrorLabel);
        this.populate(this.valueAt(data, this.dataset.responsePath) || data);
        this.setStatus(this.dataset.successLabel || 'Your changes have been saved.');
        if (this.dataset.redirectUrl) {
          window.setTimeout(() => window.location.assign(this.dataset.redirectUrl), 500);
        } else if (this.dataset.reloadSuccess === 'true') {
          window.setTimeout(() => window.location.reload(), 500);
        } else {
          this.setBusy(false);
        }
      } catch (error) {
        this.setStatus(error.message || this.dataset.saveErrorLabel || 'We could not save your changes.', true);
        this.setBusy(false);
      }
    }
  }

  if (!customElements.get('sc-customer-preferences')) {
    customElements.define('sc-customer-preferences', ScCustomerPreferences);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-customer-records"] && !Shopify.designMode) return;
  try {
    
  class ScCustomerRecords extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.status = this.querySelector('[data-sc-customer-records-status]');
      this.list = this.querySelector('[data-sc-customer-records-list]');
      this.config = this.readConfig();
      this.load();
    }

    readConfig() {
      try {
        return JSON.parse(this.querySelector('[data-sc-customer-records-config]')?.textContent || '{}');
      } catch (_error) {
        return {};
      }
    }

    async load() {
      const previewRecords = this.parsePreviewRecords();
      if (previewRecords) {
        if (!previewRecords.length) {
          this.showState(this.config.emptyText, 'empty');
          return;
        }
        this.render(previewRecords);
        return;
      }

      if (!this.config.endpoint) {
        this.showState(this.config.emptyText || 'No records are connected yet.', 'empty');
        return;
      }

      try {
        const response = await fetch(this.config.endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Request failed');
        const payload = await response.json();
        const records = this.normaliseRecords(this.getPath(payload, this.config.recordsPath));
        if (!records.length) {
          this.showState(this.config.emptyText, 'empty');
          return;
        }
        this.render(records);
      } catch (_error) {
        this.showState(this.config.errorText, 'error');
      }
    }

    normaliseRecords(value) {
      if (Array.isArray(value)) return value;
      if (value && typeof value === 'object') return [value];
      return [];
    }

    parsePreviewRecords() {
      if (!this.config.previewRecords) return null;
      try {
        return this.normaliseRecords(JSON.parse(this.config.previewRecords));
      } catch (_error) {
        return [];
      }
    }

    getPath(value, path) {
      if (!path) return value;
      return String(path).split('.').reduce((current, part) => {
        if (current == null) return undefined;
        return current[part];
      }, value);
    }

    showState(message, state) {
      if (this.status) {
        this.status.textContent = message || '';
        this.status.dataset.state = state;
      }
      if (state === 'empty' && this.dataset.hideEmpty === 'true') {
        this.closest('.sc-customer-records')?.setAttribute('hidden', '');
      }
    }

    render(records) {
      const fragment = document.createDocumentFragment();
      records.forEach((record) => fragment.appendChild(this.renderCard(record)));
      this.list.replaceChildren(fragment);
      this.list.hidden = false;
      this.status.hidden = true;
    }

    renderCard(record) {
      const article = this.element('article', 'sc-customer-records__card sc-reveal is-visible');
      const imageUrl = this.getPath(record, this.config.imagePath) || this.config.fallbackImage;
      if (imageUrl) {
        const media = this.element('div', 'sc-customer-records__media');
        const image = document.createElement('img');
        image.src = String(imageUrl);
        image.alt = this.config.fallbackAlt || '';
        image.loading = 'lazy';
        media.appendChild(image);
        article.appendChild(media);
      }

      const content = this.element('div', 'sc-customer-records__content');
      const eyebrow = this.getPath(record, this.config.eyebrowPath);
      if (eyebrow) content.appendChild(this.textElement('p', 'sc-customer-records__eyebrow', eyebrow));

      const title = this.getPath(record, this.config.titlePath) || this.config.fallbackTitle;
      content.appendChild(this.textElement('h3', 'sc-customer-records__title', title || 'Record'));

      const description = this.getPath(record, this.config.descriptionPath);
      if (description) content.appendChild(this.textElement('p', 'sc-customer-records__description', description));

      const summaries = [
        [this.config.primaryLabel, this.getPath(record, this.config.primaryPath)],
        [this.config.secondaryLabel, this.getPath(record, this.config.secondaryPath)],
      ].filter((item) => item[0] && item[1] != null && item[1] !== '');
      if (summaries.length) {
        const summary = this.element('div', 'sc-customer-records__summary');
        summaries.forEach(([label, value]) => {
          const item = this.element('div', 'sc-customer-records__summary-item');
          item.append(this.textElement('span', '', label), this.textElement('strong', '', this.format(value, 'text')));
          summary.appendChild(item);
        });
        content.appendChild(summary);
      }

      const details = this.parseDetailFields()
        .map((field) => ({ ...field, value: this.getPath(record, field.path) }))
        .filter((field) => field.value != null && field.value !== '');
      if (details.length) content.appendChild(this.renderDetails(details));

      const link = this.getPath(record, this.config.linkPath);
      if (link && this.config.linkLabel) {
        const anchor = this.textElement('a', 'sc-customer-records__link', this.config.linkLabel);
        anchor.href = String(link);
        content.appendChild(anchor);
      }

      article.appendChild(content);
      return article;
    }

    renderDetails(fields) {
      const details = this.element('details', 'sc-customer-records__details');
      details.appendChild(this.textElement('summary', '', this.config.detailsLabel || 'View details'));
      const list = this.element('dl', 'sc-customer-records__detail-list');
      fields.forEach((field) => {
        const row = this.element('div', 'sc-customer-records__detail');
        row.append(this.textElement('dt', '', field.label), this.textElement('dd', '', this.format(field.value, field.format)));
        list.appendChild(row);
      });
      details.appendChild(list);
      return details;
    }

    parseDetailFields() {
      return String(this.config.detailFields || '')
        .split('\n')
        .map((line) => {
          const [label, path, format = 'text'] = line.split('|').map((part) => part.trim());
          return { label, path, format };
        })
        .filter((field) => field.label && field.path);
    }

    format(value, format) {
      if (format === 'date') {
        const date = new Date(value);
        if (!Number.isNaN(date.getTime())) return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(date);
      }
      if (format === 'number') {
        const number = Number(value);
        if (!Number.isNaN(number)) return new Intl.NumberFormat().format(number);
      }
      if (Array.isArray(value)) return value.join(', ');
      if (value && typeof value === 'object') return Object.values(value).filter(Boolean).join(', ');
      return String(value);
    }

    element(tag, className) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      return element;
    }

    textElement(tag, className, value) {
      const element = this.element(tag, className);
      element.textContent = value == null ? '' : String(value);
      return element;
    }
  }

  if (!customElements.get('sc-customer-records')) {
    customElements.define('sc-customer-records', ScCustomerRecords);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-gift-message-editor"] && !Shopify.designMode) return;
  try {
    
  class ScGiftMessageEditor extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.designs = Array.from(this.querySelectorAll('[data-sc-gift-design]'));
      this.designValue = this.querySelector('[data-sc-gift-design-value]');
      this.variantValue = this.querySelector('[data-sc-gift-variant-value]');
      this.styleValue = this.querySelector('[data-sc-gift-style-value]');
      this.previewImage = this.querySelector('[data-sc-gift-preview-image]');
      this.previewPlaceholder = this.querySelector('[data-sc-gift-placeholder]');
      this.artwork = this.querySelector('[data-sc-gift-artwork]');
      this.artworkImage = this.querySelector('[data-sc-gift-artwork-image]');
      this.recipient = this.querySelector('[data-sc-gift-recipient]');
      this.occasion = this.querySelector('[data-sc-gift-occasion]');
      this.message = this.querySelector('[data-sc-gift-message]');
      this.previewCopy = this.querySelector('[data-sc-gift-preview-copy]');
      this.count = this.querySelector('[data-sc-gift-count]');
      this.clearButton = this.querySelector('[data-sc-gift-clear]');
      this.saveButton = this.querySelector('[data-sc-gift-save]');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-sc-gift-status]');

      this.designHandlers = this.designs.map((design) => {
        const handler = () => this.selectDesign(design);
        design.addEventListener('change', handler);
        return { design, handler };
      });
      this.messageHandler = () => this.updateMessage();
      this.message?.addEventListener('input', this.messageHandler);
      this.clearHandler = () => this.clear();
      this.clearButton?.addEventListener('click', this.clearHandler);
      this.saveHandler = () => this.saveProductLine();
      this.saveButton?.addEventListener('click', this.saveHandler);
      this.updateMessage();
    }

    disconnectedCallback() {
      this.designHandlers?.forEach(({ design, handler }) => design.removeEventListener('change', handler));
      this.message?.removeEventListener('input', this.messageHandler);
      this.clearButton?.removeEventListener('click', this.clearHandler);
      this.saveButton?.removeEventListener('click', this.saveHandler);
    }

    selectDesign(design) {
      if (this.designValue) this.designValue.value = design.dataset.designValue || design.value;
      if (this.variantValue && design.dataset.variantId) this.variantValue.value = design.dataset.variantId;
      if (this.styleValue) this.styleValue.value = design.dataset.style || '';
      if (this.previewImage && design.dataset.image) {
        this.previewImage.src = design.dataset.image;
        this.previewImage.alt = design.dataset.imageAlt || '';
        this.previewImage.hidden = false;
        if (this.previewPlaceholder) this.previewPlaceholder.hidden = true;
      }
      if (this.artwork && this.artworkImage) {
        const showArtwork = this.dataset.showArtworkPreview === 'true' && design.dataset.hasReverse === 'true';
        this.artwork.hidden = !showArtwork;
        if (showArtwork && design.dataset.artworkImage) {
          this.artworkImage.src = design.dataset.artworkImage;
          this.artworkImage.alt = design.dataset.imageAlt || '';
          this.artworkImage.hidden = false;
        }
      }
      if (this.status) this.status.textContent = `${design.dataset.designValue || design.value} ${this.dataset.selectedLabel || 'selected'}`;
    }

    updateMessage() {
      const value = this.message?.value || '';
      if (this.previewCopy) this.previewCopy.textContent = value;
      if (this.count) this.count.textContent = String(value.length);
    }

    route(path) {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}${path}`;
    }

    async request(path, options = {}) {
      const response = await fetch(this.route(path), {
        ...options,
        headers: {
          Accept: 'application/json',
          ...(options.body ? { 'Content-Type': 'application/json' } : {}),
          ...(options.headers || {}),
        },
      });
      if (!response.ok) throw new Error(this.dataset.errorLabel || 'The gift message could not be saved.');
      return response.json();
    }

    managedProperties() {
      const properties = {};
      if (this.dataset.markerKey) properties[this.dataset.markerKey] = this.dataset.markerValue || 'true';
      if (this.dataset.designKey) properties[this.dataset.designKey] = this.designValue?.value || '';
      if (this.dataset.recipientKey) properties[this.dataset.recipientKey] = this.recipient?.value.trim() || '';
      if (this.dataset.occasionKey) properties[this.dataset.occasionKey] = this.occasion?.value || '';
      if (this.dataset.messageKey) properties[this.dataset.messageKey] = this.message?.value.trim() || '';
      if (this.dataset.styleKey && this.styleValue?.value) properties[this.dataset.styleKey] = this.styleValue.value;
      return properties;
    }

    managedLines(cart) {
      const productId = Number(this.dataset.productId || 0);
      const markerKey = this.dataset.markerKey;
      const markerValue = this.dataset.markerValue || 'true';
      return (cart.items || []).filter((item) => (
        item.product_id === productId
        && item.properties
        && item.properties[markerKey] === markerValue
      ));
    }

    changeLine(id, quantity, properties) {
      const body = { id, quantity };
      if (properties) body.properties = properties;
      return this.request('cart/change.js', { method: 'POST', body: JSON.stringify(body) });
    }

    addLine(variantId, properties) {
      return this.request('cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ id: Number(variantId), quantity: 1, properties }),
      });
    }

    setBusy(busy) {
      if (this.saveButton) this.saveButton.disabled = busy;
      if (this.clearButton) this.clearButton.disabled = busy;
    }

    async saveProductLine() {
      const variantId = this.variantValue?.value;
      const message = this.message?.value.trim() || '';
      if (!variantId) {
        if (this.status) this.status.textContent = this.dataset.designRequiredLabel || 'Choose a design.';
        return;
      }
      if (this.dataset.messageRequired === 'true' && !message) {
        if (this.status) this.status.textContent = this.dataset.messageRequiredLabel || 'Add a message.';
        this.message?.focus();
        return;
      }

      this.setBusy(true);
      if (this.status) this.status.textContent = this.dataset.savingLabel || 'Saving gift message...';
      try {
        const cart = await this.request('cart.js');
        const lines = this.managedLines(cart);
        const properties = this.managedProperties();
        if (lines.length === 1 && String(lines[0].variant_id) === String(variantId)) {
          await this.changeLine(lines[0].key, 1, properties);
        } else {
          for (const line of lines) await this.changeLine(line.key, 0);
          await this.addLine(variantId, properties);
        }
        window.location.assign(this.dataset.returnUrl || this.route('cart'));
      } catch (error) {
        if (this.status) this.status.textContent = error.message || this.dataset.errorLabel;
        this.setBusy(false);
      }
    }

    async clear() {
      if (this.dataset.saveMethod === 'product_line') {
        this.setBusy(true);
        try {
          const cart = await this.request('cart.js');
          for (const line of this.managedLines(cart)) await this.changeLine(line.key, 0);
          window.location.assign(this.dataset.returnUrl || this.route('cart'));
        } catch (error) {
          if (this.status) this.status.textContent = error.message || this.dataset.errorLabel;
          this.setBusy(false);
        }
        return;
      }

      this.form?.querySelectorAll('input[type="text"], textarea, select').forEach((field) => {
        field.value = '';
      });
      if (this.designValue) this.designValue.value = '';
      this.designs.forEach((design) => { design.checked = false; });
      this.updateMessage();
      this.form?.requestSubmit();
    }
  }

  if (!customElements.get('sc-gift-message-editor')) {
    customElements.define('sc-gift-message-editor', ScGiftMessageEditor);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-personalisation-preview"] && !Shopify.designMode) return;
  try {
    
  class ScPersonalisationPreview extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.inputs = Array.from(this.querySelectorAll('[data-sc-personalisation-input]'));
      this.resetButton = this.querySelector('[data-sc-personalisation-reset]');
      this.status = this.querySelector('[data-sc-personalisation-status]');
      this.inputHandlers = this.inputs.map((input) => {
        const handler = () => this.update(input);
        input.addEventListener('input', handler);
        this.update(input);
        return { input, handler };
      });
      this.resetHandler = () => this.reset();
      this.resetButton?.addEventListener('click', this.resetHandler);
      this.submitHandler = (event) => {
        if (event.target.matches('form[action*="/cart/add"]')) this.syncToForm(event.target);
      };
      document.addEventListener('submit', this.submitHandler, true);
      this.syncToForm();
    }

    disconnectedCallback() {
      this.inputHandlers?.forEach(({ input, handler }) => input.removeEventListener('input', handler));
      this.resetButton?.removeEventListener('click', this.resetHandler);
      document.removeEventListener('submit', this.submitHandler, true);
    }

    update(input) {
      const id = input.dataset.scPersonalisationInput;
      const output = this.querySelector(`[data-sc-personalisation-output="${CSS.escape(id)}"]`);
      const count = this.querySelector(`[data-sc-personalisation-count="${CSS.escape(id)}"]`);
      if (output) output.textContent = input.value || input.placeholder || '';
      if (count) count.textContent = String(input.value.length);
      this.syncToForm();
      if (this.status) this.status.textContent = `${this.dataset.updatedLabel || 'Preview updated'}: ${input.previousElementSibling?.textContent || ''}`;
    }

    reset() {
      this.inputs.forEach((input) => {
        input.value = input.dataset.defaultValue || '';
        this.update(input);
      });
    }

    syncToForm(form) {
      if (this.dataset.syncProductForm !== 'true') return;
      const productForm = form || document.querySelector('form[action*="/cart/add"]');
      if (!productForm) return;
      this.inputs.forEach((input) => {
        const propertyName = input.dataset.propertyName;
        if (!propertyName) return;
        const fieldName = `properties[${propertyName}]`;
        let hidden = Array.from(productForm.elements).find((field) => field.name === fieldName);
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = fieldName;
          productForm.appendChild(hidden);
        }
        hidden.value = input.value;
      });
    }
  }

  if (!customElements.get('sc-personalisation-preview')) {
    customElements.define('sc-personalisation-preview', ScPersonalisationPreview);
  }

  } catch(e) { console.error(e); }
})();
})();
